import api from './api';

const profitReportService = {
  async getOptions(signal) {
    const response = await api.get('/profit-report/options', { signal });
    return response.data?.data;
  },

  async getBreakdown(dimension, params, signal) {
    const response = await api.get(`/profit-report/breakdowns/${dimension}`, { params, signal });
    return response.data?.data;
  },

  async getBreakdowns(params, signal) {
    const response = await api.get('/profit-report/breakdowns', { params, signal });
    return response.data?.data;
  },

  async syncAdsCosts(payload) {
    const response = await api.post('/profit-report/ads-costs/sync', payload);
    return response.data;
  }
};

export default profitReportService;
